module.exports = __webpack_public_path__ + "assets/i18n/fr.json";


//////////////////
// WEBPACK FOOTER
// ./src/i18n/fr.json
// module id = 1205
// module chunks = 0